import store from '@/store';

export default {
  info(message, timeout = 2500) {
    store.dispatch('toast/CREATE', { message, color: 'info', timeout });
  },
  success(message, timeout = 2500) {
    store.dispatch('toast/CREATE', { message, color: 'success', timeout });
  },
  error(message, timeout = 6000) {
    store.dispatch('toast/CREATE', { message, color: 'error', timeout });
  },
  warning(message, timeout = 4000) {
    store.dispatch('toast/CREATE', { message, color: 'warning', timeout });
  },
  notify(message, timeout = 3000) {
    store.dispatch('toast/CREATE', { message, color: 'default', timeout });
  },
  dismiss() {
    store.dispatch('toast/DISMISS');
  },
};
